export interface Interceptor<T, R> {
  (t?: T): R
  use: (fn: Function) => void
  useFns: (fns: Function[]) => void
}

/**
 * @description 拦截器
 */
export function interceptorfy<T, R>(
  fn: Function,
  context?: Record<string, unknown> | undefined
): Interceptor<T, R> {
  const interceptors: Array<Function> = []
  let chain: Array<Function> = []
  const exec = function (...args: unknown[]): R {
    if (chain.length === 0) {
      chain = interceptors.slice()
      chain.push(fn)
    }
    function run(functions: Array<Function>, args: unknown[]): R | undefined {
      const h = functions[0]
      if (h === undefined) {
        return
      }
      args.push(function next(...args: unknown[]): R {
        return run(functions.slice(1), args) as R
      })
      try {
        return h.apply(context, args)
      } catch (e) {
        console.error(e)
        throw e
      }
    }
    return run(chain, args) as R
  }

  exec.use = function (fn: Function): void {
    interceptors.push(fn)
  }

  exec.useFns = function (fns: Function[]): void {
    if (!Array.isArray(fns) || !fns.length) {
      throw new Error('[ERROR] interceptorfy: fns must be an array and not empty')
    }
    interceptors.push(...fns)
  }
  return exec
}
